/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ConversationscreateGroupSmsConversation from './ConversationscreateGroupSmsConversation';

/**
 * The ConversationsCreateGroupChatBody model module.
 * @module model/ConversationsCreateGroupChatBody
 * @version v0.3
 */
export default class ConversationsCreateGroupChatBody {
  /**
   * Constructs a new <code>ConversationsCreateGroupChatBody</code>.
   * @alias module:model/ConversationsCreateGroupChatBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ConversationsCreateGroupChatBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ConversationsCreateGroupChatBody} obj Optional instance to populate.
   * @return {module:model/ConversationsCreateGroupChatBody} The populated <code>ConversationsCreateGroupChatBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ConversationsCreateGroupChatBody();
      if (data.hasOwnProperty('conversation'))
        obj.conversation = ConversationscreateGroupSmsConversation.constructFromObject(data['conversation']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ConversationscreateGroupSmsConversation} conversation
 */
ConversationsCreateGroupChatBody.prototype.conversation = undefined;

